// Store Availability Block JavaScript
class StoreAvailabilityBlock {
  constructor() {
    this.currentVariantId = null;
    this.isUpdating = false;
    this.init();
  }

  init() {
    this.storeAvailabilityBlock = document.querySelector('.store-availability-block');
    this.variantSelectors = document.querySelectorAll('input[name="id"], select[name="id"]');
    this.productFormId = document.querySelector('product-form');
    
    if (!this.storeAvailabilityBlock) return;
    
    // Получаем текущий variant ID при инициализации
    this.currentVariantId = this.getCurrentVariantId();
    
    // Убираем текст времени pickup при инициализации
    this.removePickupTimeText();
    
    // Убираем локации "Local Pickup" при инициализации
    this.removeLocalPickupLocations();
    
    this.bindEvents();
  }

  getCurrentVariantId() {
    // Пробуем найти текущий variant ID из разных источников
    const hiddenInput = document.querySelector('input[name="id"]');
    if (hiddenInput && hiddenInput.value) {
      return hiddenInput.value;
    }

    const selectedOption = document.querySelector('select[name="id"] option:checked');
    if (selectedOption && selectedOption.value) {
      return selectedOption.value;
    }

    // Пробуем получить из data-атрибута блока
    if (this.storeAvailabilityBlock && this.storeAvailabilityBlock.dataset.variantId) {
      return this.storeAvailabilityBlock.dataset.variantId;
    }

    // Пробуем получить из URL
    const urlParams = new URLSearchParams(window.location.search);
    const variantFromUrl = urlParams.get('variant');
    if (variantFromUrl) {
      return variantFromUrl;
    }

    return null;
  }

  bindEvents() {
    // Слушатель изменения варианта через input
    this.variantSelectors.forEach(selector => {
      selector.addEventListener('change', (e) => {
        const newVariantId = e.target.value;
        if (newVariantId && newVariantId !== this.currentVariantId) {
          this.currentVariantId = newVariantId;
          this.updateAvailability(newVariantId);
        }
      });
    });

    // Слушатель через MutationObserver для динамических изменений
    if (this.productFormId) {
      const hiddenInput = this.productFormId.querySelector('input[name="id"]');
      if (hiddenInput) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
              const newVariantId = mutation.target.value;
              if (newVariantId && newVariantId !== this.currentVariantId) {
                this.currentVariantId = newVariantId;
                this.updateAvailability(newVariantId);
              }
            }
          });
        });
        
        observer.observe(hiddenInput, { 
          attributes: true, 
          attributeFilter: ['value'] 
        });

        // Дополнительно следим за изменениями значения
        hiddenInput.addEventListener('input', (e) => {
          const newVariantId = e.target.value;
          if (newVariantId && newVariantId !== this.currentVariantId) {
            this.currentVariantId = newVariantId;
            this.updateAvailability(newVariantId);
          }
        });
      }
    }

    // Слушатель custom event для вариантов
    document.addEventListener('variant:change', (e) => {
      if (e.detail && e.detail.variant && e.detail.variant.id) {
        const newVariantId = e.detail.variant.id.toString();
        if (newVariantId !== this.currentVariantId) {
          this.currentVariantId = newVariantId;
          this.updateAvailability(newVariantId);
        }
      }
    });

    // Дополнительные события для разных тем
    document.addEventListener('variantChange', (e) => {
      if (e.detail && e.detail.variant) {
        const newVariantId = e.detail.variant.id.toString();
        if (newVariantId !== this.currentVariantId) {
          this.currentVariantId = newVariantId;
          this.updateAvailability(newVariantId);
        }
      }
    });

    // Универсальный слушатель для любых изменений в форме
    document.addEventListener('change', (e) => {
      if (e.target.name === 'id' || e.target.closest('.product-form__input')) {
        setTimeout(() => {
          const newVariantId = this.getCurrentVariantId();
          if (newVariantId && newVariantId !== this.currentVariantId) {
            this.currentVariantId = newVariantId;
            this.updateAvailability(newVariantId);
          }
        }, 100); // Небольшая задержка для обновления DOM
      }
    });
  }

  updateAvailability(variantId) {
    if (!variantId || !this.storeAvailabilityBlock || this.isUpdating) return;

    this.isUpdating = true;
    this.showLoading();

    // Получаем ID секции product для правильного запроса
    const sectionId = this.getProductSectionId();
    const rootUrl = window.location.origin;
    const pathname = window.location.pathname;
    
    // Добавляем timestamp для предотвращения кеширования
    const timestamp = new Date().getTime();
    
    // Правильный URL для получения обновленной секции product с новым вариантом
    const url = `${rootUrl}${pathname}?variant=${variantId}&section_id=${sectionId}&t=${timestamp}`;

    console.log('Fetching store availability from:', url);
    console.log('Section ID:', sectionId);

    fetch(url, {
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.text();
    })
    .then(html => {
      console.log('Received HTML length:', html.length);
      this.parseAndUpdateAvailability(html);
    })
    .catch(error => {
      console.error('Error updating store availability:', error);
      this.showError();
    })
    .finally(() => {
      this.isUpdating = false;
      this.hideLoading();
    });
  }

  parseAndUpdateAvailability(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    // Ищем новый блок availability в полученном HTML
    let newAvailabilityBlock = doc.querySelector('.store-availability-block');
    
    console.log('Found new availability block:', !!newAvailabilityBlock);
    
    if (newAvailabilityBlock && newAvailabilityBlock.innerHTML.trim()) {
      // Сохраняем заголовок из текущих настроек
      const currentTitle = this.storeAvailabilityBlock.querySelector('.store-availability-title');
      const newTitle = newAvailabilityBlock.querySelector('.store-availability-title');
      
      if (currentTitle && newTitle) {
        newTitle.textContent = currentTitle.textContent;
      }
      
      // Заменяем контент
      this.storeAvailabilityBlock.innerHTML = newAvailabilityBlock.innerHTML;
      
      // Убираем текст времени pickup
      this.removePickupTimeText();
      
      // Убираем локации "Local Pickup"
      this.removeLocalPickupLocations();
      
      // Обновляем data-атрибут с новым variant ID
      this.storeAvailabilityBlock.dataset.variantId = this.currentVariantId;
      
      // Показываем блок
      this.storeAvailabilityBlock.style.display = '';
      
      console.log('Updated availability block with new content');
    } else {
      // Если нет доступности для нового варианта
      console.log('No availability found for variant:', this.currentVariantId);
      this.showNoAvailability();
    }
  }

  getProductSectionId() {
    // Пробуем найти ID секции product из DOM
    const productSection = document.querySelector('[id^="MainProduct-"]');
    if (productSection) {
      const match = productSection.id.match(/MainProduct-(.+)/);
      return match ? match[1] : 'template--main-product';
    }

    // Альтернативные способы найти section id
    const shopifySection = document.querySelector('.shopify-section[id*="product"]');
    if (shopifySection) {
      const match = shopifySection.id.match(/shopify-section-(.+)/);
      return match ? match[1] : 'template--main-product';
    }

    // Пробуем найти через data-атрибуты
    const sectionElement = document.querySelector('[data-section-type="product"]');
    if (sectionElement && sectionElement.dataset.sectionId) {
      return sectionElement.dataset.sectionId;
    }

    // Пробуем найти parent секцию от store-availability-block
    if (this.storeAvailabilityBlock) {
      const parentSection = this.storeAvailabilityBlock.closest('.shopify-section');
      if (parentSection && parentSection.id) {
        const match = parentSection.id.match(/shopify-section-(.+)/);
        return match ? match[1] : 'template--main-product';
      }
    }

    // Fallback - пробуем стандартные названия для product секций
    const possibleIds = [
      'template--main-product',
      'product-template',
      'main-product',
      'product'
    ];

    // Проверяем, какая из этих секций существует
    for (const id of possibleIds) {
      const element = document.querySelector(`#shopify-section-${id}, [data-section-id="${id}"]`);
      if (element) {
        return id;
      }
    }

    return 'template--main-product'; // Дефолтное значение
  }

  showLoading() {
    const existingLoader = this.storeAvailabilityBlock.querySelector('.store-availability-loader');
    if (existingLoader) return;

    const loader = document.createElement('div');
    loader.className = 'store-availability-loader';
    loader.innerHTML = `
      <div class="store-availability-spinner">
        <div class="spinner" style="
          width: 20px; 
          height: 20px; 
          border: 2px solid #f3f3f3; 
          border-top: 2px solid #333; 
          border-radius: 50%; 
          animation: spin 1s linear infinite;
          display: inline-block;
          margin-right: 8px;
        "></div>
        <span>Updating availability...</span>
      </div>
    `;
    
    // Добавляем стили для анимации
    if (!document.querySelector('#store-availability-spinner-styles')) {
      const style = document.createElement('style');
      style.id = 'store-availability-spinner-styles';
      style.textContent = `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .store-availability-loader {
          padding: 10px;
          text-align: center;
          background: rgba(255, 255, 255, 0.9);
          border-radius: 4px;
          margin: 10px 0;
        }
      `;
      document.head.appendChild(style);
    }
    
    this.storeAvailabilityBlock.appendChild(loader);
    this.storeAvailabilityBlock.style.opacity = '0.6';
  }

  hideLoading() {
    const loader = this.storeAvailabilityBlock.querySelector('.store-availability-loader');
    if (loader) {
      loader.remove();
    }
    this.storeAvailabilityBlock.style.opacity = '1';
  }

  showError() {
    const listContainer = this.storeAvailabilityBlock.querySelector('.store-availability-list');
    if (listContainer) {
      listContainer.innerHTML = `
        <div class="store-availability-item">
          <div class="store-availability-status">
            <svg class="icon icon-error" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="store-availability-text-error">Unable to load availability</span>
          </div>
          <button class="store-availability-retry" onclick="window.storeAvailability && window.storeAvailability.forceUpdate()" style="margin-top: 8px; padding: 4px 8px; background: #333; color: white; border: none; border-radius: 4px; cursor: pointer;">
            Retry
          </button>
        </div>
      `;
    }
  }

  showNoAvailability() {
    const listContainer = this.storeAvailabilityBlock.querySelector('.store-availability-list');
    if (listContainer) {
      listContainer.innerHTML = `
        <div class="store-availability-item">
          <div class="store-availability-status">
            <svg class="icon icon-unavailable" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 4L4 12M4 4l8 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="store-availability-text-unavailable">Pickup unavailable</span>
          </div>
        </div>
      `;
    }
  }

  // Публичный метод для принудительного обновления
  forceUpdate() {
    const currentVariant = this.getCurrentVariantId();
    if (currentVariant) {
      this.currentVariantId = null; // Сбрасываем для принудительного обновления
      this.updateAvailability(currentVariant);
    }
  }

  // Метод для удаления текста времени pickup
  removePickupTimeText() {
    if (!this.storeAvailabilityBlock) return;

    // Убираем все элементы с классом store-availability-time
    const timeElements = this.storeAvailabilityBlock.querySelectorAll('.store-availability-time');
    timeElements.forEach(element => element.remove());

    // Ищем и очищаем текст в различных элементах
    const textSelectors = [
      '.store-availability-text-available',
      '.store-availability-location', 
      '.store-availability-status span',
      '.store-availability-item span'
    ];

    textSelectors.forEach(selector => {
      const elements = this.storeAvailabilityBlock.querySelectorAll(selector);
      elements.forEach(element => {
        if (element.textContent) {
          // Убираем различные варианты текста времени
          element.textContent = element.textContent
            .replace(/,\s*usually ready in \d+\s*hours?/gi, '')
            .replace(/,\s*ready in \d+\s*hours?/gi, '')
            .replace(/,\s*\d+\s*hours?/gi, '')
            .replace(/usually ready in \d+\s*hours?/gi, '')
            .replace(/ready in \d+\s*hours?/gi, '')
            .trim();
        }
      });
    });

    // Убираем любые span элементы, содержащие только текст времени
    const allSpans = this.storeAvailabilityBlock.querySelectorAll('span');
    allSpans.forEach(span => {
      if (span.textContent) {
        const text = span.textContent.trim();
        // Если span содержит только текст времени, удаляем его
        if (text.match(/^,?\s*(usually\s+)?ready\s+in\s+\d+\s*hours?$/i) || 
            text.match(/^,?\s*\d+\s*hours?$/i) ||
            text.match(/^,\s*usually ready in/i)) {
          span.remove();
        }
      }
    });

    // Дополнительная очистка - удаляем пустые текстовые узлы и лишние запятые
    const walker = document.createTreeWalker(
      this.storeAvailabilityBlock,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    const textNodes = [];
    let node;
    while (node = walker.nextNode()) {
      textNodes.push(node);
    }

    textNodes.forEach(textNode => {
      if (textNode.textContent) {
        textNode.textContent = textNode.textContent
          .replace(/,\s*usually ready in \d+\s*hours?/gi, '')
          .replace(/,\s*ready in \d+\s*hours?/gi, '');
      }
    });
  }

  // Метод для удаления локаций "Local Pickup"
  removeLocalPickupLocations() {
    if (!this.storeAvailabilityBlock) return;

    // Ищем все элементы store-availability-item
    const availabilityItems = this.storeAvailabilityBlock.querySelectorAll('.store-availability-item');
    
    availabilityItems.forEach(item => {
      // Ищем текст локации в элементе
      const locationElement = item.querySelector('.store-availability-location');
      if (locationElement) {
        const locationText = locationElement.textContent;
        
        // Если текст содержит "Local Pickup", удаляем весь item
        if (locationText && locationText.toLowerCase().includes('local pickup')) {
          item.remove();
        }
      }
      
      // Дополнительная проверка - ищем любой текст с "Local Pickup"
      const allText = item.textContent;
      if (allText && allText.toLowerCase().includes('local pickup')) {
        item.remove();
      }
    });

    // Проверяем, остались ли локации после фильтрации
    const remainingItems = this.storeAvailabilityBlock.querySelectorAll('.store-availability-item');
    if (remainingItems.length === 0) {
      this.showNoAvailability();
    }
  }
}

// Инициализация после загрузки DOM
document.addEventListener('DOMContentLoaded', () => {
  window.storeAvailability = new StoreAvailabilityBlock();
});

// Также инициализируем при shopify:section:load (для theme editor)
document.addEventListener('shopify:section:load', (e) => {
  if (e.detail.sectionId.includes('product') || e.detail.sectionId.includes('template')) {
    setTimeout(() => {
      window.storeAvailability = new StoreAvailabilityBlock();
    }, 100);
  }
});

// Дополнительная инициализация
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.storeAvailability) {
      window.storeAvailability = new StoreAvailabilityBlock();
    }
  });
} else {
  if (!window.storeAvailability) {
    window.storeAvailability = new StoreAvailabilityBlock();
  }
}